import * as TooltipPrimitive from '@radix-ui/react-tooltip';

const TooltipTrigger = props => (
    <TooltipPrimitive.Trigger data-slot='tooltip-trigger' {...props} />
);

export default TooltipTrigger;
